var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.url)?_c('div',{staticClass:"ss_end"},[_vm._v("\n     Sharing Ended\n  ")]):_vm._e(),_c('div',{staticStyle:{"height":"100vh","width":"100%","overflow-y":"overlay"},attrs:{"id":"vxsharewindow"}})])}
var staticRenderFns = []

export { render, staticRenderFns }